/* istanbul ignore file */
// libs
import React from 'react';
import Typography from '@mui/material/Typography';
// components
import { FieldProps, TextField } from 'framework/ui/field';
// services
import { useShowContext } from 'framework/show';
import { LEAD_GRADE } from 'domain/sales/lead/shared/leadService';

const LEAD_GRADE_COLORS: Record<string, string> = {
  A_PLUS: 'success.main',
  A: 'success.light',
  B_PLUS: 'warning.main',
  B: 'warning.main',
  B_MINUS: 'warning.main',
  C: 'error.main',
  D: 'error.dark',
  DEFAULT: 'text.primary',
};

const LeadGradeField = ({ source = null, value: inputValue = null, isFull = false }: FieldProps) => {
  const { data } = useShowContext();

  const value = inputValue || (data && data.getValueBySource(source!));
  const grade = value ? LEAD_GRADE[value] : null;

  const displayValue = value && (
    <Typography
      component="span"
      variant="inherit"
      sx={{ color: LEAD_GRADE_COLORS[value] ?? LEAD_GRADE_COLORS.DEFAULT, fontWeight: 500 }}
    >
      {grade ? (isFull ? `${grade.shorthand} (${grade.name})` : grade.shorthand) : value}
    </Typography>
  );

  return <TextField value={displayValue} label="Lead grade" />;
};

export default LeadGradeField;
